export const BACKEND_URL = 'https://api.taskde.com/api/'
export const IMAGE_URL = "https://api.taskde.com"



//login routes
export const USER_LOGOUT_URL = "auth/logout";
export const USER_LOGIN_URL = "auth/login-web";
export const USER_LOGIN_PHONE_URL = "auth/phone-login-web";
export const RESEND_OTP_URL = "auth/resend-otp";

export const USER_REGISTER_URL = "auth/complete-registration";

//verify otp routes
export const VERIFY_OTP_URL = "auth/otp-verification";

//Delete account
export const DELETE_ACCOUNT_URL = "auth/delete-account";

//Home routes
export const BROWSE_SEARCH_URL = "task/buyer-search";
export const TESTIMONIAL_RATING_URL = "task/rating-slide";


//Forgot password routes
export const USER_FORGOT_PASSWORD_URL = "auth/forgot-password";
export const USER_FORGOT_PASSWORD_VIEW_URL = "auth/forgot-password-view";

//Verify Mobile Sign up routes
export const VERIFY_MOBILE_SIGN_UP = "profiles/change-number";


//Task routes
export const POST_TASK_URL = "task/task_details";
export const TASK_CATEGORY_LIST_URL = "task/list-category";
export const MY_TASK_LIST_URL = "task/task_details_my_tasks";
export const MY_TASK_SINGLE_URL = "task/single-task-details";
export const MY_TASK_LIST_SELLER_URL = "task/seller-task";
export const MAKE_AN_OFFER_URL = "task/make-task-offer";
export const BROWSE_TASK_SEARCH_URL = "task/task-details-search";
export const BROWSE_TASK_SEARCH_BUYER_URL = "task/buyer-search";
export const OFFER_LISTING_BUYER_URL = "task/task-offer-listing";
export const OFFER_LISTING_SELLER_URL = "task/seller-personal-details";
export const ASSIGN_LISTING_BUYER_URL = "task/task-assiging";
export const ASSIGN_BUYER_URL = "task/task-assiging";
export const COMPLETED_LISTING_BUYER_URL = "task/completed-task";
export const COMPLETE_BUYER_URL = "task/completed-task";
export const RELEASE_BUYER_URL = "task/release-payment";
export const CANCEL_TASK_SELLER_URL = "task/cancel-task";
export const SELLER_INFO_URL = "task/buyer-task-review";
export const TASK_REVIEW_URL = "task/buyer-review";
export const TASK_REVIEW_BUYER_URL = "task/review";


export const FAQ_LIST_URL = "faqs/faq_list";

//user routes
export const GET_USER_PROFILE_PHOTO_URL = "profiles/user-image";
export const VIEW_USER_PROFILE_URL = "profiles/user-profile-update";
export const VIEW_ADDRESS_DETAILS_URL = "profiles/user-address";
export const UPDATE_USER_PROFILE_URL = "profiles/user-profile-update";
export const UPDATE_USER_PROFILE_IMAGE_URL = "profiles/change-profile-image";
export const UPDATE_SIGNUP_USER_DETAILS_URL = "profiles/user-profile";
export const UPDATE_BILLING_ADDRESS_URL = "/profiles/user-address";
export const UPDATE_SIGNUP_BANK_DETAILS = "profiles/user-account-details";
export const GET_SERVICES_URL = "profiles/services";

//country routes
export const GET_COUNTRY_URL = "locations/country";

//state routes
export const GET_STATE_URL = "locations/country/state";


//review routes
export const GET_REVIEW_URL = "task/review-listing";

//wallet routes
export const GET_WALLET_DETAILS_URL = "payment/user-wallet/";
export const ADD_PAYMENT_RAZORPAY = "payment/success-payment";

export const ADD_UPI_ID = "payment/upi-payment";
export const ADD_PHONE_PE = "payment/phonepe-payment";
export const GET_UPI_ID = "payment/upi-list";
// export const WITHDRAW_PAYMENT = "payment/user-payout";
export const WITHDRAW_PAYMENT = "payment/payment-request";
export const OFFLINE_NOTIFICATION = "task/offline-notification";

//Notification routes
export const GET_NOTIFICATION_LIST_URL = "notifications/notification-listing";
export const MARK_AS_READ_NOTIFICATION_URL = "notifications/notification-view";
export const MARK_ALL_AS_READ_NOTIFICATION_URL = "notifications/all-notification";
export const DELETE_NOTIFICATION_URL = "notifications/delete-notification";


//Payment transaction routes
export const GET_PAYMENT_TRANSSACTION_URL = "payment/user-transaction";
export const GET_BUYER_PAYMENT_TRANSSACTION_URL = "payment/buyer-transaction";
export const GET_BUYER_SINGLE_TRANSSACTION_URL = "payment/single-transaction";

//Make an offer routes
export const MAKE_AN_OFFER_DETAILS_URL = "task/make-task-offer";
export const MAKE_AN_OFFER_COUNT_URL = "task/offer-count";
export const MAKE_AN_OFFER_LIST_URL = "task/task_details";
export const MAKE_AN_OFFER_DETAILS_FILTER_URL = "task/task_details_date_filter";

//Bank Account Details routes
export const GET_BANK_ACCOUNT_URL = "bank_accounts/user-bank-details";
export const UPDATE_BANK_ACCOUNT_URL = "bank_accounts/bank_accountdetails";

//Bank Account Details routes
export const GET_GST_URL = "bank_accounts/gst-details";
export const UPDATE_GST_DETAILS_URL = "bank_accounts/gst-details";

//Chats Details routes
export const CHAT_SEARCH_LIST_BUYER_URL = "task/chat-search";
export const CHAT_SEARCH_BUYER_URL = "task/seller-chat-list";
export const CHAT_TASK_LIST_BUYER_URL = "task/user-task-list";
export const CHAT_USER_LIST_BUYER_URL = "task/chat-user";
export const CHAT_SEARCH_SELLER_URL = "task/buyer-offer-details";
export const USER_CHAT_STATUS_URL = "profiles/user-status";

//Chats Details routes
export const CALL_DURIATION_URL = "task/call_duration";
export const CALL_LOG_URL = "task/call-log";
export const CALL_NOTIFICATION_URL = "notifications/message-notification";
export const READ_ALL_NOTIFICATION_URL = "notifications/read-all-message";


//Complaint form
export const COMPLAINT_FORM_URL = "task/user-complaint";

// PREVENT LOGIN PUSH NOTIFICATION
export const PREVENT_LOGIN_PUSH_NOTIFICATION_URL = "profiles/status-notification";


